import { TEAM } from "./data";

/* La photo ronde du prof à côté de son prénom, dans l'application. Les photos sont celles
   de la page Équipe du site : rien à saisir en double. Le planning écrit souvent le seul
   prénom (« Camille », « Carole ») : on compare donc les prénoms, sans accent ni casse,
   et on accepte une petite variante d'orthographe (Carol / Carole). */
const simple = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "")
  .toLowerCase().trim();

const PAR_PRENOM = TEAM.map((p) => ({ prenom: simple(p.name.split(" ")[0]), image: p.image }));

const photoDe = (nom) => {
  const prenom = simple(nom).split(/\s+/)[0];
  if (!prenom) return null;
  const trouve = PAR_PRENOM.find((p) => p.prenom === prenom)
    || PAR_PRENOM.find((p) => prenom.startsWith(p.prenom) || p.prenom.startsWith(prenom));
  return trouve ? trouve.image : null;
};

/** « Lydia et Noémie » ou « Noémie - Roxane » → [{ nom: "Lydia", image }, …] */
export const profsAvecPhoto = (texte) =>
  String(texte || "").split(/\s*(?:,|;|&|\/|\s-\s|\bet\b)\s*/i).map((n) => n.trim()).filter(Boolean)
    .map((nom) => ({ nom, image: photoDe(nom) }));
